import Cookies from "js-cookie";
// fetchInterceptor.js
const originalFetch = window.fetch;

window.fetch = async (url, init = {}) => {



  if (url.includes("login") || url.includes("register")|| url.includes("google")) {
    return originalFetch(url, init);
  }
    const token =  Cookies.get('auth_token');
  // Attach token if exists
  const authHeaders = token
    ? { Authorization: `Bearer ${token}` }
    : {};

  init.headers = {
    ...init.headers,
    ...authHeaders,
  };

  try {
    const response = await originalFetch(url, init);

    // Handle unauthorized
    if (response.status === 401||response.status===403) {
       
            Cookies.remove("user_data");
            Cookies.remove("auth_token");
            window.location.href = "/";

     
    }

    return response;
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};
